import { createContext, useEffect, useState } from "react";

export const AuthContext = createContext();

function AuthContextProvider({ children }) {
  const [token, setToken] = useState(
    JSON.parse(localStorage.getItem("token")) || null
  );
  // console.log(token)

  const loginUser = (token) => {
    setToken(token);
  };

  const getUserState = () => {
    setToken(token);
  };

  const logoutUser = () => {
    alert("Logout Suceessful");
    localStorage.setItem("token", JSON.stringify(null));

    setToken(null);
  };

  useEffect(() => {
    getUserState();
  }, []);

  return (
    <AuthContext.Provider value={{ token,loginUser, logoutUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export default AuthContextProvider;
